import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Avatar } from 'antd';
import { openDrawer } from "../../../store/reducers/menu";
import { MenuFoldOutlined, MenuUnfoldOutlined, LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { LOGOUT_AUTH } from '@/store/reducers/auth';
import { get_oidc_logout_url, user_logout_log, session_logout_api } from '@/utils/api';
import { defaultColors, getAccentColor } from '@/themes/antd-theme';
import { useTheme } from '@/App';

const Footer = () => {
  const { isDark } = useTheme();
  const { theme_color } = useSelector((state) => state.company_profile);
  const accentColor = getAccentColor(theme_color, isDark);
  const { drawerOpen } = useSelector((state) => state.menu);
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [userprofile, setUserprofile] = useState();

  const handleDrawerToggle = () => {
    setOpen(!open);
    dispatch(openDrawer({ drawerOpen: !open }));
  };

  useEffect(() => {
    setOpen(drawerOpen);
  }, [drawerOpen]);

  useEffect(() => {
    try {
      const storedData = localStorage.getItem("user_details");
      if (storedData && storedData !== "undefined" && storedData !== "null") {
        setUserprofile(JSON.parse(storedData));
      }
    } catch (error) {
      console.error("Error parsing user_details from localStorage:", error);
    }
  }, [auth?.userModel?.isLogin]);

  const stringAvatar = (name) =>
    name
      ?.trim()
      ?.split(/\s+/)
      ?.map((part) => part?.charAt(0)?.toUpperCase())
      ?.join("");

  const user_logout_log_data = async () => {
    try {
      await user_logout_log({}, (res) => {
        if (res?.data?.status === "success") {
          console.log(res?.data?.message);
        }
      });
    } catch (error) {
      console.error("Error while logout:", error);
    }
  };

  const handleLogout = async () => {
    await user_logout_log_data();
    // Destroy the server-side session (cookie auth) + audit; for an SSO login it also returns the
    // Zitadel end-session URL.
    const ssoLogoutUrl = await session_logout_api();
    const isSso = localStorage.getItem('auth_mode') === 'sso';
    dispatch(LOGOUT_AUTH());
    if (isSso) {
      localStorage.removeItem('Token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('auth_mode');
      window.location.href = get_oidc_logout_url();
      return;
    }
    localStorage.clear();
    if (ssoLogoutUrl) {
      window.location.href = ssoLogoutUrl;
      return;
    }
    navigate("/");
  };
  return (
    // <div className="w-full flex justify-end items-center gap-3 p-4 border-t bg-white shadow-sm">
    //   {/* Drawer Toggle */}
    //   <button
    //     onClick={handleDrawerToggle}
    //     className={`p-2 rounded-lg transition-all duration-300 ${
    //       open
    //         ? "bg-teal-800 text-white hover:bg-teal-900"
    //         : "bg-gray-600 text-white hover:bg-gray-700"
    //     }`}
    //   >
    //     {open ? (
    //       <MenuFoldOutlined className="text-lg transition-transform duration-200 hover:scale-110" />
    //     ) : (
    //       <MenuUnfoldOutlined className="text-lg transition-transform duration-200 hover:scale-110" />
    //     )}
    //   </button>

    //   {/* MBMR / MBPR Switch */}
    //   <div className="flex rounded-lg overflow-hidden shadow">
    //     <button
    //       onClick={() => dispatch(setChangeModule("prod"))}
    //       disabled={
    //         selectedModule === "pack" &&
    //         [
    //           "/addRecipeForm",
    //           "/add-packaging",
    //           "/edit-process",
    //           "/edit-operation",
    //           "/new-operation",
    //           "/recipeMetadata",
    //         ].includes(location?.pathname)
    //       }
    //       className={`px-4 py-2 font-semibold transition ${
    //         selectedModule === "prod"
    //           ? "bg-teal-800 text-white"
    //           : "bg-gray-100 text-gray-800 hover:bg-gray-200"
    //       }`}
    //     >
    //       MBMR
    //     </button>
    //     <button
    //       onClick={() => dispatch(setChangeModule("pack"))}
    //       disabled={
    //         selectedModule === "prod" &&
    //         [
    //           "/addRecipeForm",
    //           "/add-packaging",
    //           "/edit-process",
    //           "/edit-operation",
    //           "/new-operation",
    //           "/recipeMetadata",
    //         ].includes(location?.pathname)
    //       }
    //       className={`px-4 py-2 font-semibold transition ${
    //         selectedModule === "pack"
    //           ? "bg-teal-800 text-white"
    //           : "bg-gray-100 text-gray-800 hover:bg-gray-200"
    //       }`}
    //     >
    //       MBPR
    //     </button>
    //   </div>

    //   {/* Test / Production Switch */}
    //   <div className="flex rounded-md border border-gray-300 overflow-hidden">
    //     <button
    //       onClick={() => handleClick("test")}
    //       className={`px-3 py-1.5 text-sm font-medium transition ${
    //         selectedTestProd === "test"
    //           ? "bg-gray-200 text-gray-900"
    //           : "bg-white text-gray-700 hover:bg-gray-100"
    //       }`}
    //     >
    //       Test
    //     </button>
    //     <button
    //       onClick={() => handleClick("production")}
    //       className={`px-3 py-1.5 text-sm font-medium transition ${
    //         selectedTestProd === "production"
    //           ? "bg-gray-200 text-gray-900"
    //           : "bg-white text-gray-700 hover:bg-gray-100"
    //       }`}
    //     >
    //       Production
    //     </button>
    //   </div>
    // </div>
    <div className="border-t border-white/10 p-3">
      <div className={`flex items-center ${open ? 'justify-end' : 'justify-center flex-col gap-3'}`}>
        {/* Action Buttons */}
        <div className={`flex items-center ${open ? 'gap-2' : 'flex-col gap-2'}`} style={{ zIndex: 1000, position: 'relative' }}>
          <button
            onClick={handleLogout}
            className="p-2 rounded-lg hover:bg-white/10 transition-all duration-200 text-white hover:text-white"
          >
            <LogoutOutlined style={{ fontSize: '18px' }} />
          </button>
          <button
            onClick={handleDrawerToggle}
            className="p-2 rounded-lg hover:bg-white/10 transition-all duration-200 text-white hover:text-white"
          >
            {open ? (
              <MenuFoldOutlined style={{ fontSize: '18px' }} />
            ) : (
              <MenuUnfoldOutlined style={{ fontSize: '18px' }} />
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Footer;
